<ng-container *transloco="let t; prefix: 'sideNav.menu'">
  @let itm = item();
  @if (!itm.target && !itm.disabled) {
    <a
      [tabindex]="0"
      [attr.data-id]="itm.label"
      [routerLink]="itm.link"
      [class.is-active]="isActive()"
      [queryParams]="itm.queryParams"
      (click)="onNavigate()"
      mat-list-item
    >
      @if (itm.icon) {
        <rma-icon [glyph]="itm.icon" [class.collapsed]="collapsed()" [title]="collapsed() ? t(itm.label) : ''" matListItemIcon />
      }
      @if (!collapsed()) {
        <div class="flex items-center gap-2">
          <span [innerHtml]="t(itm.label)"></span>

          @if (itm.isBeta) {
            <rma-beta-tooltip position="inline" />
          }
        </div>
      }
    </a>
  } @else {
    <a
      [tabindex]="0"
      [attr.target]="itm.target"
      [attr.data-id]="itm.label"
      [href]="itm.disabled ? 'javascript:void(0)' : itm.link"
      [class.is-active]="isActive()"
      [disabled]="itm.disabled"
      mat-list-item
    >
      @if (itm.icon) {
        <rma-icon [glyph]="itm.icon" [class.collapsed]="collapsed()" [title]="collapsed() ? t(itm.label) : ''" matListItemIcon />
      }
      @if (!collapsed()) {
        <div class="flex items-center gap-2">
          <span [innerHtml]="t(itm.label)"></span>
          @if (itm.isBeta) {
            <rma-beta-tooltip position="inline" />
          }
        </div>
      }
    </a>
  }
</ng-container>
